import { Injectable } from '@angular/core';
import { FileHelperService } from '@app/services';
import { ReportFilter } from '@reporting/interfaces/report-filter.interface';
import { EnhancedPayrollReport } from '@reporting/interfaces/report.interface';
import { Report } from '@reporting/services/queries/report';

@Injectable()
export class EnhancedPayrollReportingService {
    constructor(private fileService: FileHelperService) {}

    async display(
        report: EnhancedPayrollReport,
        filters: ReportFilter[],
        additionalParams?: [string, string][]
    ): Promise<Report> {
        return this.fetch(report, filters, additionalParams);
    }

    exportExcel(report: Report, filters: ReportFilter[]): Promise<boolean> {
        return this.export(report, filters, 'xlsx');
    }

    exportPDF(report: Report, filters: ReportFilter[]): Promise<boolean> {
        return this.export(report, filters, 'pdf');
    }

    exportCSV(report: Report, filters: ReportFilter[]): Promise<boolean> {
        return this.export(report, filters, 'csv');
    }

    export(report: Report, filters: ReportFilter[], contentType: string): Promise<boolean> {
        return report.filters([...filters, { name: 'export', value: 'true' }]).export(contentType);
    }

    private fetch(
        report: EnhancedPayrollReport,
        filters: ReportFilter[],
        additionalParams?: [string, string][]
    ): Promise<Report> {
        return new Report<typeof report.additionalReportFields>(this.fileService)
            .name(report.reportName)
            .page(null)
            .filters(filters)
            .withAdditionalReportFields(report.additionalReportFields)
            .withAdditionalParameters(additionalParams)
            .get();
    }
}
